import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Cube, Database, Files, Cloud, Eye, Copy } from '@phosphor-icons/react';
import { toast } from 'sonner';

const HerokuDashboard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await axios.get(`/api/heroku/dashboard`, { withCredentials: true });
      setData(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  if (!data) return <div className="p-8 text-center text-slate-500">Loading...</div>;

  return (
    <div className="space-y-12 animate-in fade-in slide-in-from-bottom-2 duration-500">
      <div>
        <h1 className="text-4xl font-black mb-2 text-[#8b60ed]">HEROKU DASHBOARD</h1>
        <p className="text-slate-400">Overview of Apps, Templates, and Accounts.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="border border-[#8b60ed]/20 bg-card p-6 flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-wider text-slate-500 mb-1">Live Apps</div>
            <div className="text-4xl font-black text-white">{data.live_apps}</div>
          </div>
          <Cube size={48} className="text-[#8b60ed] opacity-50" />
        </div>
        <div className="border border-[#8b60ed]/20 bg-card p-6 flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-wider text-slate-500 mb-1">Templates</div>
            <div className="text-4xl font-black text-white">{data.templates}</div>
          </div>
          <Files size={48} className="text-[#8b60ed] opacity-50" />
        </div>
        <div className="border border-[#8b60ed]/20 bg-card p-6 flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-wider text-slate-500 mb-1">Accounts</div>
            <div className="text-4xl font-black text-white">{data.accounts}</div>
          </div>
          <Database size={48} className="text-[#8b60ed] opacity-50" />
        </div>
      </div>

      <div>
        <h2 className="text-2xl font-bold mb-6">RECENT HEROKU DEPLOYMENTS</h2>
        <div className="border border-white/10 bg-card overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-white/10 bg-black/20">
                <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">App Name</th>
                <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">Template</th>
                <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">Account</th>
                <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">Status</th>
                <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">URL</th>
              </tr>
            </thead>
            <tbody>
              {data.recent.map(dep => (
                <tr key={dep.id} className="border-b border-white/5 hover:bg-white/5 transition-colors">
                  <td className="p-4 font-mono text-sm">{dep.app_name || '-'}</td>
                  <td className="p-4 text-sm">{dep.template_name}</td>
                  <td className="p-4 text-sm">{dep.account_label}</td>
                  <td className="p-4 text-sm">
                    <span className={`px-2 py-1 text-xs font-bold tracking-wider ${
                      dep.status === 'live' ? 'bg-[#39FF14]/10 text-[#39FF14] border border-[#39FF14]/20' : 
                      dep.status === 'failed' ? 'bg-red-500/10 text-red-500 border border-red-500/20' : 
                      'bg-yellow-500/10 text-yellow-500 border border-yellow-500/20'
                    }`}>
                      {dep.status}
                    </span>
                  </td>
                  <td className="p-4 text-sm">
                    {dep.public_url ? (
                      <div className="flex items-center gap-2">
                        <div className="bg-[#0A0B0E] border border-white/10 px-2 py-1 text-xs text-slate-400 font-mono truncate w-48 select-all" title={dep.public_url}>
                          {dep.public_url}
                        </div>
                        <button 
                          onClick={() => { navigator.clipboard.writeText(dep.public_url); toast.success("Copied!"); }}
                          className="text-slate-400 hover:text-white transition-colors p-1"
                        >
                          <Copy size={16} />
                        </button>
                        <a href={dep.public_url} target="_blank" rel="noreferrer" className="text-slate-400 hover:text-[#8b60ed] transition-colors p-1">
                          <Eye size={16} />
                        </a>
                      </div>
                    ) : '-'}
                  </td>
                </tr>
              ))}
              {data.recent.length === 0 && (
                <tr>
                  <td colSpan="5" className="p-8 text-center text-slate-500">No deployments yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default HerokuDashboard;